export const ru = {
    no: 'Нет',
    'not-selected': 'Не выбрано',
    yes: 'Да'
};
